module.exports = __webpack_public_path__ + "media/site_templates/www.heatingservices.com.au/images/our_services_3-56fc1534a517bdab433d63ef02d6cbd8.jpg";